/**
 * GatewayProvider — initializes the gateway WebSocket connection at app root.
 *
 * Wraps the app to ensure gateway connection lifecycle is managed.
 * In local dev mode (no Clerk), uses a dev token.
 * In production, obtains a Lexiun JWT via the auth exchange endpoint.
 */

import { useGateway } from "@/hooks/useGateway";

interface GatewayProviderProps {
  children: React.ReactNode;
  /** Override gateway URL (default: auto-detect from location). */
  gatewayUrl?: string;
  /** Override gateway auth token (default: "lexdev" for local dev). */
  gatewayToken?: string | null;
  /** Disable auto-connection (for testing). */
  disabled?: boolean;
}

export function GatewayProvider({ children, gatewayUrl, gatewayToken, disabled }: GatewayProviderProps) {
  useGateway({
    url: gatewayUrl,
    gatewayToken: gatewayToken ?? undefined,
    autoConnect: !disabled,
  });

  return <>{children}</>;
}
